import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useT } from "../i18n/LanguageContext";

export default function FinalCTA({ onRequest }) {
    const { t } = useT();
    return (
        <section
            className="relative py-24 md:py-32 bg-charcoal-surface border-t border-white/5 overflow-hidden"
            data-testid="final-cta-section"
        >
            <div className="absolute inset-0 opacity-30">
                <img
                    src="https://customer-assets.emergentagent.com/job_wynwood-short-term/artifacts/g8ohd223_Imagen%2021-4-26%20a%20las%2021.23.jpeg"
                    alt=""
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/90 to-charcoal/60" />
            </div>

            <div className="relative mx-auto max-w-5xl px-6 md:px-12 text-center">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >
                    <div className="flex items-center justify-center gap-3 mb-6">
                        <span className="inline-block w-8 h-[1px] bg-gold" />
                        <span className="text-[11px] tracking-[0.4em] uppercase text-gold font-semibold">
                            {t("fcta.overline")}
                        </span>
                        <span className="inline-block w-8 h-[1px] bg-gold" />
                    </div>
                    <h2 className="font-display text-4xl md:text-6xl font-semibold tracking-tight leading-[1.02]">
                        {t("fcta.heading_before")}
                        <br />
                        <span className="italic font-normal text-gold">
                            {t("fcta.heading_highlight")}
                        </span>
                    </h2>
                    <p className="mt-8 text-white/60 max-w-xl mx-auto text-base md:text-lg">
                        {t("fcta.body")}
                    </p>
                    <button
                        onClick={onRequest}
                        className="mt-10 group inline-flex items-center gap-3 bg-gold text-charcoal px-10 py-5 text-xs tracking-[0.2em] uppercase font-semibold hover:bg-gold-hover transition-all hover:-translate-y-0.5"
                        data-testid="final-cta-btn"
                    >
                        {t("fcta.cta")}
                        <ArrowRight
                            size={16}
                            className="transition-transform group-hover:translate-x-1"
                        />
                    </button>
                </motion.div>
            </div>
        </section>
    );
}
